import Backbone from "backbone";
import f from "../funcs";
import Events from "../classes/Events";
import $ from "jquery";
import ContextMenuView from "../classes/ContextMenuView";
import "plugins/isVisible";


let $body;

const FeedSlider = Events.extend("FeedSlider", {
    init(params, context) {
        if ( !$body ) { $body = $(document.body); }

        params = f.deepMixin({
            width: "auto",
            /** Single move width in px */
            speed: 40,
            /** Speed up ratio */
            speedUp: 0.05
        }, params);

        /** Speedup, see TablListView */
        if ( params.hasOwnProperty("getContentWidth") ) {
            this.getContentWidth = params.getContentWidth;
        }

        this.initElements(params, context);

        this.width = params.width === "auto" || !params.width
            ? this.wrap.offsetWidth
            : params.width;

        this.getContentWidth() <= this.getWidth() - 40 // 40 - paddings, when feedSlider is disabled
            ? this.$wrap.addClass("FeedSlider-disable")
            : this.$wrap.removeClass("FeedSlider-disable");

        this._currentSpeedUp = 1;
        this._speedUp = params.speedUp;
        this.speed = params.speed;

        window.feedSlider = this;

        return this;
    },

    initElements(params, context) {
        /** Order is important! */
        this.initElAndWrap(params, context);
        this.initControlButtons();
        this.initDropdownMenu();
        this.initActions();
    },

    initElAndWrap(params, context) {
        if ( params.el && params.wrap ) {
            this.el = params.el;
            this.$el = $(params.el);
            this.wrap = params.wrap;
            this.$wrap = $(params.wrap);
        } else {
            this.el = context;
            this.$el = $(context);
            this.$el.wrap("<div class='FeedSlider'></div>");
            /** Inject html */
            this.$el.before("<span class='FeedSlider--button FeedSlider--moveLeftButton'></span>");
            this.$el.after("<span class='FeedSlider--button FeedSlider--moveRightButton'></span>");
            this.$el.after("<span class='FeedSlider--button FeedSlider--dropdownMenuButton'></span>");
            this.wrap = this.el.parentNode;
            this.$wrap = this.$el.parent();
        }
        if ( params.className ) { this.$wrap.addClass(params.className); }
    },

    initControlButtons() {
        this.$moveLeftButton = this.$wrap.children(".FeedSlider--moveLeftButton");
        this.$moveRightButton = this.$wrap.children(".FeedSlider--moveRightButton");
        this.$dropdownMenuButton = this.$wrap.children(".FeedSlider--dropdownMenuButton");
    },

    initDropdownMenu() {
        this.dropdownMenuCollection = new Backbone.Collection();

        this.dropdownMenu = new ContextMenuView({
            collection: this.dropdownMenuCollection,
            touchOpenTimeout: 100,
            addClassName: `FeedSlider--dropdownMenu ${ this.$wrap.hasClass("dark-theme") ? "dark-theme" : ""}`
        });

        this.dropdownMenu.on("beforeShow", () => {
            const tabs = this.$el.context.children;
            const menuItems = [];

            for (let i = 0; i < tabs.length; ++i) {
                menuItems.push({
                    name: tabs[i].innerText,
                    className: `FeedSlider--dropdownMenuItem ${/[^-]-active/.test(tabs[i].className) ? "FeedSlider--dropdownMenuItem-active" : ""}`,
                    onClick: () => {
                        tabs[i].click();
                        this.setX(
                            this.getX()
                                + tabs[i].getBoundingClientRect().x
                                - tabs[i].parentNode.getBoundingClientRect().x
                        );
                    }
                });
            }

            this.dropdownMenuCollection.set(menuItems);
            this.dropdownMenu.render();
        });
    },

    initActions() {
        this.listenTo(
            this.$wrap.children(".FeedSlider--moveLeftButton, .FeedSlider--moveRightButton"),
            "click",
            (e) => {
                e.preventDefault();
                this.singleMove(
                    $(e.target).hasClass("FeedSlider--moveLeftButton") ? -1 : 1
                );
            }
        );

        this.listenTo(
            this.$wrap.children(".FeedSlider--moveLeftButton, .FeedSlider--moveRightButton"),
            "mousedown touchstart",
            (e) => {
                e.preventDefault();
                this.startMove(
                    $(e.target).hasClass("FeedSlider--moveLeftButton") ? -1 : 1
                );
            }
        );

        this.listenTo($(window), "mouseup touchend", () => {this.stopMove();});

        this.listenTo(
            this.$el,
            "wheel",
            (e) => {
                e.preventDefault();
                this.singleMove(
                    -Math.sign(e.originalEvent.wheelDelta)
                );
            }
        );

        this.listenTo(
            this.$dropdownMenuButton,
            "click",
            (e) => {
                e.preventDefault();
                this.dropdownMenu.moveTo(e.pageX, e.pageY);
                this.dropdownMenu.trigger("beforeShow");
                this.dropdownMenu.show();
            }
        );
    },

    /** Return scrollLeft property of mover element */
    getX() {
        return this.$el.context.scrollLeft;
    },

    /** Set scrollLeft property of mover element */
    setX(x) {
        this.$el.context.scrollLeft = x;
    },

    /** Single move without speed up */
    singleMove(vector) {
        this.setX(vector * this.speed + this.getX());
    },

    /** Single move with speed up */
    singleSpeedUpMove(vector) {
        this._currentSpeedUp += this._speedUp;
        this.setX(vector * this.speed * this._currentSpeedUp + this.getX());
    },

    /** Start moving with speed up */
    startMove(vector) {
        $body.addClass("no-select");
        clearInterval(this.interval);
        this.interval = setInterval(this.singleSpeedUpMove.bind(this, vector), 30);
    },

    /** Stop moving */
    stopMove() {
        $body.removeClass("no-select");
        this._currentSpeedUp = 1;
        clearInterval(this.interval);
    },

    getWidth() {
        return this.width;
    },

    getContentWidth() {
        const $el = this.$el;
        let width = 0;

        $el.children().each(function() {
            const el = $(this);
            if ( el.isVisible() ) {
                width += el.outerWidth(true);
            }
        });

        return width;
    },

    update(params = {}) {
        if ( params.hasOwnProperty("width") ) {
            this.width = params.width === "auto"
                ? this.wrap.offsetWidth
                : params.width;
        }

        this.getContentWidth() <= this.getWidth() - 40
            ? this.$wrap.addClass("FeedSlider-disable")
            : this.$wrap.removeClass("FeedSlider-disable");
    },

    destroy() {
        clearInterval(this.interval);
        clearTimeout(this.timer);
        this.clearEvents();
    }
});

$.fn.feedSlider = function(params) {
    return this.each(function() {
        if ( params == "destroy" ) {
            const feedSlider = $(this).data("feedSlider");
            if ( feedSlider ) {
                feedSlider.destroy();
                $(this).data("feedSlider", null);
            }
        } else {
            $(this).data("feedSlider", new FeedSlider(params, this));
        }
    });
};

export default FeedSlider;
